import { ModalService } from './../../../services/modal.service';
import { Component, OnInit, TemplateRef, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalType } from '../../../models/modal.type.enum';

@Component({
  selector: 'app-delete-appraisee',
  templateUrl: './delete-appraisee.component.html',
  styleUrls: ['./delete-appraisee.component.scss'],
})
export class DeleteAppraiseeComponent implements OnInit {
  @Input() processDurationAppraiseeId: number;

  modalRef: BsModalRef;
  isDeleteModalHidden: boolean;
  constructor(
    private bsModalService: BsModalService,
    public modalService: ModalService
  ) {
    this.hideModalSubscriber();
  }

  ngOnInit() {}

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.bsModalService.show(template);
  }

  changeModalBehaviour() {
    this.isDeleteModalHidden = !this.isDeleteModalHidden;
    this.modalService.changeModalVisibility(this.isDeleteModalHidden);
  }

  onOkClicked() {
    this.modalService.acceptModal({
      modalType: ModalType.Delete,
      isAppraiseeDeletetion: true,
      processDurationAppraiseeId: this.processDurationAppraiseeId,
    });
  }

  hideModal() {
    if (!this.modalRef) {
      return;
    }
    this.modalRef.hide();
  }

  private hideModalSubscriber() {
    this.modalService.hideModal$.subscribe((x) => this.hideModal());
  }
}
